import { api } from "./client";

// Free-write journal surface — /api/v1/journal-entries.
//
// Distinct from api/journal.js, which owns /journal (the conversational
// check-in). Same naming collision the backend router had to navigate;
// keeping the two clients separate keeps it visible.
//
// Nothing written here is scored. A free-write entry's extraction binds
// on journal_entry_id, which cannot satisfy the RCI join — see
// app/models/journal_entry.py. The client doesn't enforce that; it just
// shouldn't imply otherwise in any copy it drives.
export const journalEntriesApi = {
  // body: required, non-empty. entryDate: local YYYY-MM-DD, defaults
  // server-side to today when omitted.
  create: (body, entryDate, token) =>
    api.post(
      "/journal-entries",
      entryDate ? { body, entry_date: entryDate } : { body },
      token
    ),

  // One page, newest first. `before` is the strict date cursor handed
  // back as `next_before` — same idiom as rciApi.history.
  list: (token, { limit = 30, before = null } = {}) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (before) params.set("before", before);
    return api.get(`/journal-entries?${params.toString()}`, token);
  },

  // Single-day lookup. Used by the day-detail cross-link to answer
  // "is there a free-write entry for this date?" without pulling the
  // whole history down to filter it here.
  listByDate: (date, token) =>
    api.get(`/journal-entries?date=${encodeURIComponent(date)}`, token),

  // The bulk form of the same existence question: which dates in a
  // range have entries, and how many. Dates and counts only — no
  // bodies. Used by the Signal History timeline to mark days that have
  // writing behind them without fetching the writing.
  datesInRange: (start, end, token) => {
    const params = new URLSearchParams({ start, end });
    return api.get(`/journal-entries/dates?${params.toString()}`, token);
  },
};
